import { render } from "./Analytics.vue?vue&type=template&id=2887b3f3"
import script from "./Analytics.vue?vue&type=script&lang=js"
export * from "./Analytics.vue?vue&type=script&lang=js"

import "./Analytics.vue?vue&type=style&index=0&id=2887b3f3&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__